/**
 * Asset Column Definitions for SelectionTable
 *
 * Defines 2 columns:
 * 1. Status - Asset status chip (Active, Deleted, etc.)
 * 2. Name - Asset identifier with group/domain metadata
 */

import type { ColumnDef, SortingState } from '@tanstack/react-table';

import type { SearchableListItem } from '@/sections/attacks/attackPaths/components/wizards/hooks';

import { NameCell, StatusCell } from './shared';

/**
 * Column definitions for asset selection table
 */
export const assetColumns: ColumnDef<SearchableListItem>[] = [
  {
    id: 'status',
    accessorFn: row => row.status,
    header: 'Status',
    cell: ({ row }) => (
      <StatusCell status={row.original.status} entityType="asset" />
    ),
    size: 70,
  },
  {
    id: 'name',
    accessorFn: row => row.name,
    header: 'Name',
    cell: ({ row }) => (
      <div className="truncate" title={row.original.name}>
        <NameCell name={row.original.name} metadata={row.original.metadata} />
      </div>
    ),
    sortingFn: 'alphanumeric',
    meta: { flexible: true },
  },
];

/**
 * Default sort state: name ascending (alphabetical)
 */
export const assetDefaultSort: SortingState = [{ id: 'name', desc: false }];
